export const userMenu = [
  {
    name: "Home",
    path: "/",
    icon: "fa-solid fa-house-chimney",
  },
  {
    name: "Appointments",
    path: "/appointments",
    icon: "fa-sharp fa-solid fa-list",
  },
  {
    name: "Apply Doctor",
    path: "/apply-doctor",
    icon: "fa-solid fa-user-doctor",
  },
  {
    name: "Profile",
    path: "/profile",
    icon: "fa-solid fa-user",
  },
  {
    name: "Medicines",
    path: "/medicines",
    icon: "fa-solid fa-tablets",
  },

  //   {
  //     name: "Logo",
  //     path: "/logout",
  //     icon: "fa-solid fa-right-from-bracket",
  //   },
];

//admin menu
export const adminMenu = [
  {
    name: "Home",
    path: "/",
    icon: "fa-solid fa-house-chimney",
  },
  {
    name: "Doctors",
    path: "/admin/doctors",
    icon: "fa-solid fa-user-doctor",
  },
  {
    name: "Users",
    path: "/admin/users",
    icon: "fa-solid fa-user",
  },
  {
    name: "Profile",
    path: "/profile",
    icon: "fa-solid fa-user",
  },
  //   {
  //     name: "Logout",
  //     path: "/logout",
  //     icon: "fa-solid fa-right-from-bracket",
  //   },
];
